import { firebaseUrl } from '@/firebase/cloudFunctions';
import { Stripe } from 'stripe';

export const getStripeCustomer = async (data: {
  email?: string;
  uid?: string;
}): Promise<Stripe.Customer | undefined> => {
  try {
    const result = await fetch(firebaseUrl + 'getStripeCustomer', {
      method: 'POST',
      body: JSON.stringify({
        email: data.email,
        uid: data.uid
      })
    });
    if (!result.ok) {
      console.error(`Failed to get stripe customer`);
      return undefined;
    }
    return await result.json();
  } catch (error) {
    console.error(`Failed to get stripe customer: ${error}`);
    return undefined;
  }
};

export const createOrMatchStripeCustomer = async (data: {
  email: string;
  uid: string;
}): Promise<Stripe.Customer | undefined> => {
  try {
    const result = await fetch(firebaseUrl + 'createOrMatchStripeCustomer', {
      method: 'POST',
      body: JSON.stringify({
        email: data.email,
        uid: data.uid
      })
    });
    if (!result.ok) {
      console.error(`Failed to create or match stripe customer`);
      return undefined;
    }
    return await result.json();
  } catch (error) {
    console.error(`Failed to create or match stripe customer: ${error}`);
    return undefined;
  }
};
